/* ============================================
   [Fix-13] 商品ページの追従カートバー（ドロワー型）
   株式会社ニューポート 2026-08-24

   なぜドロワー型か：
     Growth Rock の実A/B（モバイル、各群3,000コンバージョン超、14日間）で
     ・追従バー→ATCへスクロールするだけの型：CVRに有意差なし
     ・追従バー→その場で選択完結するドロワー型：注文 +5.2%（98%有意）
     本商品群はサイズが複数あるため、ドロワー型でないと意味がない。

   設計方針：
     このバーは「実フォームのリモコン」として作っています。
     独自に /cart/add.js を叩かず、テーマ本体のラジオボタンと
     追加ボタンをクリックします。こうすることでバリエーション切替、
     サンプル自動付与、dataLayer、在庫判定がすべてそのまま動きます。

   追加後のフィードバック：
     2026-09-16 より np-cart-toast.js（cart:update を拾ってトーストを出す）に統一。
     以前はこのバー自体を 5 秒間「カートに追加しました / カートを見る」に
     切り替えていたが、トーストと二重になるため showAdded() の呼び出しを外した
     （関数本体と CSS の .np-sticky--added は戻せるように残してある）。

   [Fix-13b] 2026-08-24 の実機検証で見つかった2件を修正
     (1) 数量が反映されない
         数量UIの実体は .quantity-dropdown の <select> で、
         input[name="quantity"] は display:none の控えだった。
         控えだけ書き換えてもカートには 1 個しか入らなかった。
         → select と input の両方を更新し、上限も select の選択肢数に合わせる。
     (2) サイズ変更直後に前のサイズの価格が数秒残る
         テーマのバリエーション切替はセクション再取得を伴うため、
         固定秒数後に描き直す方式だと間に合わず、
         250mL を選んでも ¥2,640（50mL）のまま表示される瞬間があった。
         価格の誤表示は信用に直結するので、秒数ではなく
         「実際に価格が変わるまで待つ」方式に変更した。
         待つ間は価格を「…」に伏せる。最大 2.4 秒で打ち切り。
   ============================================ */
(function () {
  var SEL = {
    atc: '.product-form-buttons button.add-to-cart-button, .product-form-buttons button[type="submit"]',
    qty: '.product-form-buttons input[name="quantity"]',
    qtySelect: '.product-form-buttons select',
    price: '.product-information product-price, product-price',
    gallery: 'media-gallery img, .product-media img'
  };

  function isPdp() { return /\/products\//.test(location.pathname); }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var bar, sheet, io, lastAtc, addedTimer, sheetQty = 1, added = false;
  var priceWait = null;   // 価格待ち中はシートの価格を描き換えない

  /* 価格の抜き出し
     product-price の中には通常価格ブロックとセール価格ブロックが両方存在し、
     表示されていない方も textContent には含まれる。そのまま使うと
     「¥2,640(税込) セール価格 ¥2,640(税込) 通常価格」になるので、
     offsetParent で実際に表示されているブロックだけを拾う。 */
  function priceText() {
    var p = $(SEL.price);
    if (!p) return '';
    var blocks = $$('.price__sale, .price__regular', p);
    var host = null;
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].offsetParent !== null) { host = blocks[i]; break; }
    }
    var clone = (host || p).cloneNode(true);
    $$('.visually-hidden', clone).forEach(function (n) { n.remove(); });
    var t = clone.textContent.replace(/\s+/g, '').trim();
    if (t.length > 0 && t.length <= 22) return t;
    var m = t.match(/[¥￥][\d,]+(?:\(税込\))?/);
    return m ? m[0] : t.slice(0, 22);
  }

  function heroSrc() {
    var img = $(SEL.gallery);
    return img ? (img.currentSrc || img.src || '') : '';
  }

  function productTitle() {
    var h = $('h1');
    return h ? h.textContent.trim() : document.title;
  }

  function optionGroups() {
    var groups = [];
    $$('variant-picker fieldset').forEach(function (fs) {
      var legend = $('legend', fs);
      var radios = $$('input[type="radio"]', fs);
      if (!radios.length) return;
      groups.push({
        name: legend ? legend.textContent.trim() : '',
        items: radios.map(function (r) {
          return {
            value: r.value,
            checked: !!r.checked,
            available: r.getAttribute('data-option-available') !== 'false',
            label: r.closest('label')
          };
        })
      });
    });
    return groups;
  }

  function hasChoices() {
    var g = optionGroups();
    return g.length > 0 && g.some(function (x) { return x.items.length > 1; });
  }

  function buildBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'np-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'カートに追加');
    bar.innerHTML =
      '<img class="np-sticky__img" alt="" />' +
      '<span class="np-sticky__meta">' +
        '<span class="np-sticky__name"></span>' +
        '<span class="np-sticky__price"></span>' +
      '</span>' +
      '<button type="button" class="np-sticky__cta">カートに追加</button>';
    document.body.appendChild(bar);

    $('.np-sticky__cta', bar).addEventListener('click', function () {
      if (added) { window.location.href = '/cart'; return; }
      if (hasChoices()) openSheet();
      else { clickRealAtc(); }   // 追加後の表示は np-cart-toast.js が担当
    });
    return bar;
  }

  function syncBar() {
    if (!bar || added) return;
    var img = $('.np-sticky__img', bar);
    var src = heroSrc();
    if (src && img.src !== src) img.src = src;
    $('.np-sticky__name', bar).textContent = productTitle();
    if (!priceWait) $('.np-sticky__price', bar).textContent = priceText();

    var atc = $(SEL.atc);
    var cta = $('.np-sticky__cta', bar);
    if (atc && atc.disabled) {
      cta.disabled = true;
      cta.textContent = atc.textContent.trim() || '在庫切れ';
    } else {
      cta.disabled = false;
      cta.textContent = hasChoices() ? 'サイズを選ぶ' : 'カートに追加';
    }
  }

  /* 現在は未使用（np-cart-toast.js に統一）。トーストをやめてバー側に戻す場合は
     clickRealAtc() の直後で呼ぶ。 */
  function showAdded() {
    if (!bar) return;
    added = true;
    bar.classList.add('np-sticky--added', 'np-sticky--in');
    $('.np-sticky__name', bar).textContent = 'カートに追加しました';
    $('.np-sticky__price', bar).textContent = '';
    var cta = $('.np-sticky__cta', bar);
    cta.disabled = false;
    cta.textContent = 'カートを見る';
    clearTimeout(addedTimer);
    addedTimer = setTimeout(function () {
      added = false;
      bar.classList.remove('np-sticky--added');
      syncBar();
    }, 5000);
  }

  function clickRealAtc() {
    var atc = $(SEL.atc);
    if (!atc || atc.disabled) return false;
    atc.click();
    return true;
  }

  /* ---------- ボトムシート ---------- */
  function buildSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'np-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="np-sheet__backdrop" data-np-close></div>' +
      '<div class="np-sheet__panel" role="dialog" aria-modal="true" aria-label="購入オプション">' +
        '<button type="button" class="np-sheet__close" aria-label="閉じる" data-np-close>×</button>' +
        '<div class="np-sheet__head">' +
          '<img class="np-sheet__img" alt="" />' +
          '<div class="np-sheet__headtext">' +
            '<p class="np-sheet__name"></p>' +
            '<p class="np-sheet__price"></p>' +
          '</div>' +
        '</div>' +
        '<div class="np-sheet__options"></div>' +
        '<div class="np-sheet__qty">' +
          '<span class="np-sheet__qtylabel">数量</span>' +
          '<button type="button" class="np-sheet__step" data-np-step="-1" aria-label="数量を減らす">−</button>' +
          '<span class="np-sheet__qtyval">1</span>' +
          '<button type="button" class="np-sheet__step" data-np-step="1" aria-label="数量を増やす">＋</button>' +
        '</div>' +
        '<button type="button" class="np-sheet__submit">カートに追加する</button>' +
      '</div>';
    document.body.appendChild(sheet);

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-np-close]')) { closeSheet(); return; }
      var step = e.target.closest('[data-np-step]');
      if (step) { bumpQty(Number(step.getAttribute('data-np-step'))); return; }
      var chip = e.target.closest('[data-np-opt]');
      if (chip) { chooseOption(chip); return; }
      if (e.target.closest('.np-sheet__submit')) {
        applyQty();
        clickRealAtc();
        closeSheet();   // 追加後の表示は np-cart-toast.js が担当
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
    });
    return sheet;
  }

  /* [Fix-13b] 数量の上限はテーマの <select> の選択肢数に合わせる。 */
  function maxQty() {
    var sel = $(SEL.qtySelect);
    if (sel && sel.options && sel.options.length) return sel.options.length;
    return 10;
  }

  function bumpQty(d) {
    sheetQty = Math.min(maxQty(), Math.max(1, sheetQty + d));
    var v = $('.np-sheet__qtyval', sheet);
    if (v) v.textContent = String(sheetQty);
  }

  /* [Fix-13b] 数量の実体は <select>。input[name="quantity"] は控えなので両方更新する。 */
  function applyQty() {
    var v = String(sheetQty);
    var sel = $(SEL.qtySelect);
    if (sel) {
      var hit = false;
      for (var i = 0; i < sel.options.length; i++) {
        if (String(sel.options[i].value) === v) { hit = true; break; }
      }
      if (hit) {
        sel.value = v;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var q = $(SEL.qty);
    if (q) {
      q.value = v;
      q.dispatchEvent(new Event('input', { bubbles: true }));
      q.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* [Fix-13b] サイズ変更時、価格が実際に切り替わるまで旧価格を出さない。 */
  function chooseOption(chip) {
    var gi = Number(chip.getAttribute('data-np-group'));
    var ii = Number(chip.getAttribute('data-np-opt'));
    var groups = optionGroups();
    var item = groups[gi] && groups[gi].items[ii];
    if (!item || !item.label) return;

    // 選択状態だけ先に反映（テーマの再描画を待たずに押した感触を返す）
    $$('.np-sheet__chip', sheet).forEach(function (b) {
      var on = b === chip;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var before = priceText();
    priceWait = before;
    var pe = $('.np-sheet__price', sheet);
    if (pe) pe.textContent = '…';
    if (bar) { var bp = $('.np-sticky__price', bar); if (bp) bp.textContent = '…'; }

    item.label.click();

    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var now = priceText();
      var settled = (now && now !== before) || tries >= 12;   // 200ms x 12 = 2.4秒で打ち切り
      if (!settled) return;
      clearInterval(iv);
      priceWait = null;
      if (sheet && !sheet.hidden) renderSheet();
      syncBar();
    }, 200);
  }

  function renderSheet() {
    if (!sheet) return;
    var img = $('.np-sheet__img', sheet);
    var src = heroSrc();
    if (src && img.src !== src) img.src = src;
    $('.np-sheet__name', sheet).textContent = productTitle();
    if (!priceWait) $('.np-sheet__price', sheet).textContent = priceText();

    var box = $('.np-sheet__options', sheet);
    box.innerHTML = '';
    optionGroups().forEach(function (g, gi) {
      if (g.items.length < 2) return;
      var wrap = document.createElement('div');
      wrap.className = 'np-sheet__group';
      var lab = document.createElement('span');
      lab.className = 'np-sheet__grouplabel';
      lab.textContent = g.name;
      wrap.appendChild(lab);
      var row = document.createElement('div');
      row.className = 'np-sheet__chips';
      g.items.forEach(function (it, ii) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'np-sheet__chip' +
          (it.checked ? ' is-selected' : '') +
          (it.available ? '' : ' is-unavailable');
        b.setAttribute('data-np-group', gi);
        b.setAttribute('data-np-opt', ii);
        b.setAttribute('aria-pressed', it.checked ? 'true' : 'false');
        if (!it.available) b.disabled = true;
        b.textContent = it.value;
        row.appendChild(b);
      });
      wrap.appendChild(row);
      box.appendChild(wrap);
    });

    var sel = $(SEL.qtySelect);
    var q = $(SEL.qty);
    var cur = sel ? Number(sel.value) : (q ? Number(q.value) : 1);
    sheetQty = Math.min(maxQty(), Math.max(1, cur || 1));
    $('.np-sheet__qtyval', sheet).textContent = String(sheetQty);

    var atc = $(SEL.atc);
    var sub = $('.np-sheet__submit', sheet);
    sub.disabled = !!(atc && atc.disabled);
    sub.textContent = sub.disabled ? '在庫切れ' : 'カートに追加する';
  }

  function openSheet() {
    buildSheet();
    renderSheet();
    sheet.hidden = false;
    document.body.style.overflow = 'hidden';
    // rAF はバックグラウンドタブで発火しないことがあるので setTimeout を使う
    setTimeout(function () { if (sheet) sheet.classList.add('np-sheet--in'); }, 16);
    var first = $('.np-sheet__chip', sheet) || $('.np-sheet__submit', sheet);
    if (first) first.focus({ preventScroll: true });
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('np-sheet--in');
    document.body.style.overflow = '';
    setTimeout(function () { if (sheet) sheet.hidden = true; }, 240);
  }

  /* ---------- 表示制御 ---------- */
  function watchAtc() {
    var atc = $(SEL.atc);
    if (!atc) return;
    if (atc === lastAtc && io) return;
    lastAtc = atc;
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        // 実ボタンが上に抜けたらバーを出す
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        buildBar();
        syncBar();
        if (!added) bar.classList.toggle('np-sticky--in', show);
      });
    }, { threshold: 0 });
    io.observe(atc);
  }

  function run() {
    if (!isPdp()) {
      if (bar) bar.classList.remove('np-sticky--in');
      return;
    }
    buildBar();
    watchAtc();
    syncBar();
    if (sheet && !sheet.hidden) renderSheet();
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 250); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  ['variant:update', 'variant:change', 'cart:update'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });
})();
